import { BulkReassigned, TaskControllerApi } from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

/**
 *
 * @author [Rajkumar Rathod]
 */
interface Params {
  bulkResolved: BulkReassigned;
  xTENANTID?: string;
}

export const useBatchResolve = () =>
  useMutationWithLoading(async (params: Params) =>
    new TaskControllerApi(getConfigObject()).resolvedTasks(
      params.bulkResolved,
      params.xTENANTID
    )
  );


export const usePatientResolveTask = () =>
  useMutationWithLoading(async (params: Params) =>
    new TaskControllerApi(getConfigObject()).resolveTaskByTaskId(
      params.bulkResolved,
      params.xTENANTID
    )
  );
